import { createSelector } from 'reselect';
import get from 'lodash/get';
import find from 'lodash/find';

const orderShippingGroups = (state) => get(state, 'orderDetails.data.delivery.groups', []);

const orderShippingInfoSelector = createSelector(
    orderShippingGroups,
    (deliveryGroups) =>
        find(deliveryGroups, { type: 'HOME' }) || find(deliveryGroups, { type: 'STORE' })
);

const orderSdpuInfoSelector = createSelector(orderShippingGroups, (deliveryGroups) =>
    find(deliveryGroups, { type: 'BOPIS' })
);

const orderShippingToHomeInfoSelector = createSelector(orderShippingGroups, (deliveryGroups) =>
    find(deliveryGroups, { type: 'HOME' })
);

const orderSelectedShippingMethods = createSelector(orderShippingGroups, (deliveryGroups) => {
    const shippingInfo =
        find(deliveryGroups, { type: 'HOME' }) || find(deliveryGroups, { type: 'STORE' });
    let orderShippingMethod = {};
    if (shippingInfo) {
        orderShippingMethod = find(shippingInfo.serviceLevels.data, { selected: true }) || {};
    }
    return orderShippingMethod;
});

export {
    orderShippingInfoSelector,
    orderSelectedShippingMethods,
    orderSdpuInfoSelector,
    orderShippingToHomeInfoSelector,
};
